import Rate from './rate'
export { RateProps as IRateProps } from './rate'
export default Rate
